import axios from 'axios';

const apolloAuth = axios.create({
  baseURL: process.env.REACT_APP_APOLLO_URL || 'https://apolo.duelaser.com/api',
});

const ApolloAuth = {
  async login({ email, password }) {
    const { data } = await apolloAuth.post('/auth/login', { email, password });
    return data;
  },

  async refresh({ refreshToken }) {
    const { data } = await apolloAuth.post('/auth/refresh', { refreshToken });
    return data;
  },

  async logout({ refreshToken }) {
    await apolloAuth.post('/auth/logout', { refreshToken });
  },

  async forgotPassword({ email }) {
    const { data } = await apolloAuth.post('/auth/forgot-password', { email });
    return data;
  },
};

export default ApolloAuth;
